export interface ILanding {
  step1: {
    title: string;
    subtitle: string;
    serviceSeeker: string;
    serviceProvider: string;
    selectOption: string;
    continueButton: string;
  };
  step2: {
    client: {
      title: string;
      subtitle: string;
      registerButton: string;
    };
    provider: {
      title: string;
      subtitle: string;
      continueButton: string;
      nextStepHint: string;
      isCompanyLabel: string;
    };
    fields: {
      name: {
        label: string;
        placeholder: string;
        error: string;
      };
      email: {
        label: string;
        placeholder: string;
        error: string;
        validationError: string;
      };
      password: {
        label: string;
        placeholder: string;
        error: string;
        validationError: string;
      };
      companyName: {
        label: string;
        placeholder: string;
        error: string;
      };
    };
  };
  step3: {
    title: string;
    subtitle: string;
    registerButton: string;
    fields: {
      categories: {
        label: string;
        error: string;
      };
      workAreas: {
        label: string;
        error: string;
      };
      phoneNumber: {
        label: string;
        placeholder: string;
      };
      countryCode: {
        label: string;
      };
    };
  };
  step4: {
    title: string;
    message: string;
    emailAddress: string;
    confirmText: string;
  };
  common: {
    backButton: string;
    termsText: string;
  };
}

export const LandingResourcesDE: ILanding = {
  step1: {
    title: "Hilfe finden oder Aufträge erhalten",
    subtitle: "Einfach und schnell in Ihrer Nähe",
    serviceSeeker: "Service suchen",
    serviceProvider: "Service anbieten",
    selectOption: "Bitte wählen Sie eine Option aus, um fortzufahren.",
    continueButton: "Fortfahren",
  },
  step2: {
    client: {
      title: "Account erstellen",
      subtitle: "Bitte geben Sie Name, E-Mail und Passwort ein.",
      registerButton: "Gratis registrieren",
    },
    provider: {
      title: "Account erstellen",
      subtitle:
        "Bitte geben Sie Name, Firmenname (falls Sie ein Unternehmen sind), E-Mail und Passwort ein.",
      continueButton: "Fortfahren",
      nextStepHint: "Nur noch ein Schritt",
      isCompanyLabel: "Sind Sie ein Unternehmen?",
    },
    fields: {
      name: {
        label: "Vor- und Nachname",
        placeholder: "Vor- und Nachname",
        error: "Name ist erforderlich",
      },
      email: {
        label: "E-Mail",
        placeholder: "E-Mail",
        error: "E-Mail ist erforderlich",
        validationError: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      },
      password: {
        label: "Passwort",
        placeholder: "Passwort",
        error: "Passwort ist erforderlich",
        validationError: "Das Passwort muss mindestens 6 Zeichen lang sein",
      },
      companyName: {
        label: "Firmenname",
        placeholder: "Firmenname",
        error: "Firmenname ist erforderlich",
      },
    },
  },
  step3: {
    title: "Letzter Schritt",
    subtitle:
      "Bitte geben Sie Services, Arbeitsorte und optional Ihre Telefonnummer ein.",
    registerButton: "Gratis registrieren",
    fields: {
      categories: {
        label: "Services auswählen",
        error: "Bitte wählen Sie mindestens eine Kategorie aus",
      },
      workAreas: {
        label: "Arbeitsorte auswählen",
        error: "Bitte wählen Sie mindestens ein Arbeitsgebiet aus",
      },
      phoneNumber: {
        label: "Telefonnummer",
        placeholder: "Telefonnummer",
      },
      countryCode: {
        label: "Ländercode",
      },
    },
  },
  step4: {
    title: "Fast geschafft!",
    message:
      "Bitte überprüfen Sie jetzt Ihre E-Mails. Sie haben eine Nachricht von contact@servi.co erhalten - klicken Sie auf den Bestätigungslink, um Ihre Registrierung abzuschließen.",
    emailAddress: "contact@servi.co",
    confirmText:
      "Falls Sie keine E-Mail finden, prüfen Sie bitte auch Ihren Spam-Ordner.",
  },
  common: {
    backButton: "Zurück",
    termsText:
      "Mit der Registrierung akzeptiere ich die AGB und die Datenschutzerklärung und bestätige, dass ich mindestens 18 Jahre alt bin.",
  },
};

export const LandingResourcesEN: ILanding = {
  step1: {
    title: "Find Help or Get Jobs",
    subtitle: "Easy and fast in your area",
    serviceSeeker: "Looking for service",
    serviceProvider: "Offering service",
    selectOption: "Please select an option to continue.",
    continueButton: "Continue",
  },
  step2: {
    client: {
      title: "Create Account",
      subtitle: "Please enter name, email and password.",
      registerButton: "Register for free",
    },
    provider: {
      title: "Create Account",
      subtitle:
        "Please enter name, company name (if you are a business), email and password.",
      continueButton: "Continue",
      nextStepHint: "Just one more step",
      isCompanyLabel: "Are you a business?",
    },
    fields: {
      name: {
        label: "First and Last Name",
        placeholder: "First and Last Name",
        error: "Name is required",
      },
      email: {
        label: "Email",
        placeholder: "Email",
        error: "Email is required",
        validationError: "Please enter a valid email address",
      },
      password: {
        label: "Password",
        placeholder: "Password",
        error: "Password is required",
        validationError: "Password must be at least 6 characters long",
      },
      companyName: {
        label: "Company Name",
        placeholder: "Company Name",
        error: "Company name is required",
      },
    },
  },
  step3: {
    title: "Final Step",
    subtitle:
      "Please enter services, work locations and optionally phone number.",
    registerButton: "Register for free",
    fields: {
      categories: {
        label: "Select Services",
        error: "Please select at least one category",
      },
      workAreas: {
        label: "Select Work Locations",
        error: "Please select at least one work area",
      },
      phoneNumber: {
        label: "Phone Number",
        placeholder: "Phone Number",
      },
      countryCode: {
        label: "Country Code",
      },
    },
  },
  step4: {
    title: "Almost Done!",
    message:
      "Please check your emails now. You have received a message from contact@servi.co - click on the confirmation link to complete your registration.",
    emailAddress: "contact@servi.co",
    confirmText:
      "If you can't find the email, please also check your spam folder.",
  },
  common: {
    backButton: "Back",
    termsText:
      "By registering, I accept the Terms and Conditions and Privacy Policy and confirm that I am at least 18 years old.",
  },
};
